import {maybe} from '@freckle/maybe'
import {saferStringify} from '@freckle/parser'

export class ActionableError extends Error {}

export class NonActionableError extends Error {}

export class ActionableHttpError extends ActionableError {
  constructor(
    public url: string,
    public method: string,
    public status: number,
    public response: {response: Response; text?: string; json?: unknown},
    public cause?: unknown
  ) {
    super(`${method} ${url} responded with ${status} - ${getResponseMessage(response)}`)
    this.name = 'ActionableHttpError'
  }
}

export class ActionableUnknownError extends ActionableError {
  constructor(
    message: string,
    public cause: unknown
  ) {
    super(message)
    this.name = 'ActionableUnknownError'
  }
}

export class NonActionableHttpError extends NonActionableError {
  constructor(
    public url: string,
    public method: string,
    public status: number,
    public response: {response: Response; text?: string; json?: unknown},
    public cause?: unknown
  ) {
    super(`${method} ${url} responded with ${status} - ${getResponseMessage(response)}`)
    this.name = 'NonActionableHttpError'
  }

  hasValidationError(name: string): boolean {
    return this.getErrorNames()?.includes(name) ?? false
  }
  getErrorNames(): string[] | null {
    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.response.json as any)?.validationErrors?.map(({name}: {name: string}) => name) ?? []
    )
  }
}

const getResponseMessage = (response: {response: Response; text?: string; json?: unknown}) => {
  return maybe(
    () => response.text,
    json => saferStringify(json),
    response.json
  )
}

export class ClientNetworkError extends NonActionableError {
  constructor(
    err: string,
    public cause: TypeError
  ) {
    super(err)
    this.name = 'ClientNetworkError'
  }
}

export class ClientMalformedRequestError extends ActionableError {
  constructor(
    err: string,
    public cause: TypeError
  ) {
    super(err)
    this.name = 'ClientMalformedRequestError'
  }
}

export class ClientRequestAbortError extends NonActionableError {
  constructor(
    err: string,
    public cause: Error
  ) {
    super(err)
    this.name = 'ClientRequestAbortError'
  }
}
